import script from "./ThreeModelViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ThreeModelViewer.vue?vue&type=script&setup=true&lang=js"

import "./ThreeModelViewer.vue?vue&type=style&index=0&id=6425ed84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6425ed84"]])

export default __exports__